//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    ifSysEdit: {
      type: Boolean,
      default: false
    },
    systemdata: null,
    systemlist: null
  },
  created: function created() {
    if (this.ifSysEdit) {
      this.formSys = this.systemdata;
    } else {
      this.formSys = this.formSysdefault;
    }
  },
  data: function data() {
    return {
      formSys: {},
      formSysdefault: {},
      rules: {
        routeId: [{
          required: true,
          message: '请输入路由编号',
          trigger: 'blur'
        }],
        routeUri: [{
          required: true,
          message: '请输入路由路径',
          trigger: 'blur'
        }],
        // systemId: [
        //   { required: true, message: '请选择系统名称', trigger: 'blur' }
        // ],
        routeOrder: [{
          required: true,
          message: '请输入路由执行顺序',
          trigger: 'blur'
        }],
        filters: [{
          required: true,
          message: '请输入过滤器字符串集合',
          trigger: 'blur'
        }],
        predicates: [{
          required: true,
          message: '请输入断言字符串集合',
          trigger: 'blur'
        }]
      }
    };
  },
  methods: {
    cancelDailog: function cancelDailog() {
      this.$emit('RoutesSubmit', {
        bool: false
      });
    },
    commit: function commit() {
      var _this = this;
      this.$refs.formSys.validate(function (valid) {
        if (valid) {
          _this.$emit('RoutesSubmit', {
            bool: true,
            formData: _this.formSys
          });
        } else {
          _this.$message({
            message: '请完善信息填写',
            type: 'warning'
          });
          return false;
        }
      });
    },
    confirmsure: function confirmsure(bool) {
      if (bool) {
        this.commit();
      }
    }
  }
};